// Navigation Component - Handles wizard navigation buttons
import { t } from '../../i18n.js';

export class Navigation {
  constructor(wizard) {
    this.wizard = wizard;
  }
  
  render() {
    const navigation = document.createElement('div');
    navigation.className = 'wizard-navigation';
    
    // Only show Import button for consolidated view
    const importButton = document.createElement('button');
    importButton.type = 'button';
    importButton.className = 'wizard-btn wizard-btn-primary wizard-import-btn';
    importButton.disabled = !this.wizard.canProceed();
    importButton.textContent = t('import_to_crm');
    importButton.onclick = () => this.wizard.finishWizard();
    
    navigation.appendChild(importButton);
    
    return navigation;
  }
}
